import { useLocation } from "react-router-dom";
import "../../../styles/animations.css";
import Header from "../../../components/v6/Header";
import StepQuestUnlocked from "../DetailMultipleChoice/Step/StepQuestUnlocked";

import { useOnboardingNavigation } from "../../../hooks/useOnboardingNavigation";
import { WAITLIST_DATA } from "../../../components/Onboarding/onboardingData";

function UnlockedQuestPage() {
  const location = useLocation();
  const { questDetailsData } = location.state || {};
  const { containerProps, onboardingDialog } = useOnboardingNavigation(
    questDetailsData,
    WAITLIST_DATA,
  );

  return (
    <>
      <div
        {...containerProps}
        className="flex overflow-hidden flex-col  mx-auto w-full bg-[#E1D2F3] max-w-[480px] "
      >
        <div className="flex flex-col w-full min-h-screen ">
          <div className="sticky top-0 left-0 w-full bg-[#E1D2F3] z-50 ">
            <Header backgroundHeader="bg-transparent" />
          </div>

          <div className="flex flex-col w-[calc(368px-60px)] xs:w-[368px]  xs:justify-center xs:items-center flex-1 mx-auto ">
            <div className="w-full ">
              <StepQuestUnlocked questDetailsData={questDetailsData} />
            </div>
          </div>
        </div>
      </div>
      {onboardingDialog}
    </>
  );
}

export default UnlockedQuestPage;
